import { styled, css } from 'styled-components';

import { CssRecord } from '@src/types/utils/styles';

import { TextLinkProps } from './types';

const variantStyles: CssRecord<Required<TextLinkProps>['variant']> = {
  black: css`
    color: var(--color-numa-black--400);

    &:hover {
      color: var(--color-primary);
    }
  `,
  white: css`
    color: var(--color-white);

    &:hover {
      color: var(--color-numa-black--400);
    }
  `,
  'black-regular': css`
    color: var(--color-numa-black--400);
    font: var(--font-body--regular);

    &:hover {
      color: var(--color-primary);
      font: var(--font-body--regular);
    }
  `,
  'white-regular': css`
    color: var(--color-white);
    font: var(--font-body--regular);

    &:hover {
      color: var(--color-numa-black--400);
      font: var(--font-body--regular);
    }
  `,
};

const wrapperStyles = css<TextLinkProps>`
  display: inline-flex;
  padding: 0;
  border: none;
  font: var(--font-body--medium);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  background-color: transparent;
  cursor: pointer;

  ${({ variant = 'black' }) => variantStyles[variant]}
`;
export const LinkWrapper = styled.a<Pick<TextLinkProps, 'variant' | 'isSmall'>>`
  ${wrapperStyles}

  ${({ isSmall }) =>
    isSmall &&
    css`
      font: var(--font-body-small--medium);
    `}
`;
export const ButtonWrapper = styled.button<TextLinkProps>`
  border: none;
  font: inherit;

  ${wrapperStyles}
`;
